"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 23 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M17.218 5.505c-1.679 0-3.165 1.243-4.213 3.252-.567.841-1.764 2.242-3.794 2.951-4.084 1.427-7.209 1.665-7.205 1.666C.881 13.373 0 14.527 0 16c0 1.469.876 2.62 1.916 2.62h.009c.02.003.888.148 2.085.386l3.874 5.788a.5.5 0 10.831-.556l-3.306-4.94c1.286.28 2.698.625 3.809.998 1.586.53 2.946 1.95 3.614 2.748.083.1.154.198.22.292 1.044 1.956 2.513 3.16 4.166 3.16C20.46 26.495 23 21.885 23 16c0-5.885-2.54-10.495-5.782-10.495zM9.535 19.346c-2.794-.935-7.258-1.681-7.528-1.719C1.461 17.627 1 16.882 1 16s.461-1.627 1.042-1.628c.132-.009 3.28-.246 7.5-1.72a8.418 8.418 0 002.502-1.387A18.099 18.099 0 0011.436 16c0 1.766.232 3.413.64 4.859-.733-.625-1.591-1.195-2.541-1.513zm7.683 6.149c-2.246 0-4.189-3.268-4.667-7.49h1.901a1.902 1.902 0 001.808-1.994l-.024-.499a1.902 1.902 0 00-1.994-1.808l-1.652-.002c.232-1.771.72-3.358 1.381-4.59.133-.213.227-.384.283-.494.822-1.313 1.855-2.114 2.964-2.114C19.81 6.505 22 10.853 22 16s-2.19 9.495-4.782 9.495z" })));
};
var SvgMegaphone = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgMegaphone;
var templateObject_1;
